import { getAnniGoalAmountPer } from '../AnniProjectPopupInterface';
import { breakpoint } from '@/helpers/BreakpointHelper';
import React, { FC, useEffect, useState } from 'react';
import styled from 'styled-components';

const Graph = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 10px 0 15px;
`;
const GoalAmount = styled.div`
  width: 100%;
  height: 10px;
  border-radius: 5px;
  background: #ebebeb;
`;
const AchieveAmount = styled.div`
  height: 100%;
  width: 67%;
  background: #1cabe2;
  border-radius: 5px;
`;
const AchieveNum = styled.div`
  color: #1cabe2;
  font-weight: bold;
  margin-left: 15px;
  ${breakpoint(`mobile`)} {
    margin-left: 13px;
  }
`;
const GoalNum = styled.div`
  margin-left: auto;
  color: #bebfc1;
  margin-right: 15px;
  ${breakpoint(`mobile`)} {
    margin-right: 13px;
  }
`;

const AnniGiftGraph: FC<{ total: number; goal: number }> = ({
  total,
  goal,
}) => {
  const [graphWidth, setGraphWidth] = useState(0);

  // 모금액 퍼센트 계산
  const getGapchWidth = (goalAmount: number, totalAmount: number) => {
    if (goalAmount === 0) {
      setGraphWidth(0);
    } else {
      const gWidth = getAnniGoalAmountPer(goalAmount, totalAmount);
      setGraphWidth(gWidth > 100 ? 100 : gWidth);
    }
  };
  useEffect(() => {
    getGapchWidth(goal || 0, total || 0);
  }, [total, goal]);

  return (
    <Graph>
      <GoalAmount>
        <AchieveAmount
          css={`
            width: ${graphWidth}%;
          `}
        />
      </GoalAmount>
      <AchieveNum>후원 {total?.toLocaleString() || 0}원</AchieveNum>
      <GoalNum>목표 {goal?.toLocaleString() || 0}원</GoalNum>
    </Graph>
  );
};

export default AnniGiftGraph;
